import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/es5/locale/es";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#5D4DF7",
        secondary: "#241d3b",
        accent: "#5D4DF7",
        error: "#ff3860",
        info: colors.indigo.accent2,
        success: "#14c39a",
        warning: colors.orange.darken1,
        anchor: "#5D4DF7",
        // All keys will generate theme styles,
        // Here we add a custom `background` color
        background: {
          base: "#f4f1ff", //All component background
          darken1: "#e8e6f3", // Toolbar
          darken2: "#cdcae0", // Scrollbar
          darken3: "#b0a8cb"
        }
      }
    }
  },
  lang: {
    locales: { es },
    current: "es"
  },
  icons: {
    iconfont: "mdi"
  }
});
